import { Card, Typography } from '@mui/material';
import { TbIcon } from 'components/Figma';
import { ReactNode } from 'react';

export interface FilterableCountCardProps {
  title: ReactNode;
  count: number;
  chip: ReactNode;
  comparisonLabel: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  testId?: string;
}

export function FilterableCountCard({
  title,
  count,
  chip,
  comparisonLabel,
  selected = false,
  onClick = undefined,
  testId = undefined,
}: FilterableCountCardProps) {
  return (
    <Card
      className={`transition-all duration-200 flex pt-5 pb-4 px-6 gap-3 rounded-lg border border-solid ${
        onClick ? 'cursor-pointer' : ''
      } ${selected ? 'bg-[#E6F2F9] border-[#8BC3E5]' : 'bg-snow-50 border-snow-50'}`}
      onClick={onClick}
      data-testid={testId}
      data-selected={selected}
    >
      <div className="flex w-full">
        <div className="text-sm pt-1">
          {selected ? (
            <TbIcon name="Cross" size="lg" className="mr-2" />
          ) : (
            <TbIcon name="FunnelOutlined" size="lg" className="mr-2" />
          )}
        </div>
        <div className="w-full">
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            <span>{title}</span>
          </Typography>
          <div className="flex w-full justify-between mt-2 relative">
            <div>
              <div className="absolute bottom-0">
                <Typography variant="h1" sx={{ fontWeight: 700 }} data-testid={testId ? `${testId}-count` : undefined}>
                  {count}
                </Typography>
              </div>
            </div>
            <div>
              <div className="flex justify-end mb-1">{chip}</div>
              <div className="text-xs font-normal text-text-secondary text-nowrap">{comparisonLabel}</div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
